import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Routes } from './routes';
import { AppThemeProvider, GlobalStyle } from './shared';
import { fetchFeatureFlag, fetchToolInfo, fetchToolsConfig } from '@clatter/platform';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { store } from './store';
import { Loader } from '@clatter/ui';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

function App() {
  const persistor = persistStore(store);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchFeatureFlag());
    dispatch(fetchToolInfo());
    dispatch(fetchToolsConfig());
  }, [dispatch]);

  // @ts-ignore - ReactPortal type incompatibility between @types/react-dom and @types/react in React 18
  const loader = <Loader />;

  return (
    <PersistGate loading={loader} persistor={persistor}>
      <AppThemeProvider>
        <GlobalStyle />
        <Routes />
      </AppThemeProvider>
    </PersistGate>
  );
}

export default App;
